import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { KWHText, WattText } from "../Shared/Methods";

interface props {
  series?: any;
  type?: any;
  labels?: any;
  SeriesKey: string;
  colour: string;
  YAxisText?: string;
  XAxisText?: string;
}

function BarChart({
  series,
  type,
  labels,
  SeriesKey,
  colour,
  YAxisText,
  XAxisText,
}: props) {
  const [toolTipValue, setToolTipValue] = useState<any>();

  return (
    <>
      <ReactApexChart
        options={{
          noData: {
            text: "No Data Found",
          },
          chart: {
            type: "bar",
            // height: 400,
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              borderRadius: 2,
            },
          },

          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 5,
            colors: ["transparent"],
          },
          xaxis: {
            categories: labels?.map((ele: any) => ele),
            offsetX: 10,
            title: {
              text: XAxisText ? XAxisText : undefined,
              style: {
                fontSize: "15px",
              },
            },
          },
          yaxis: {
            axisBorder: {
              color: "red",
            },
            title: {
              text: YAxisText ? YAxisText : undefined,
              style: {
                fontSize: "15px",
              },
            },
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: (value, { w, seriesIndex, dataPointIndex }) => {
                return SeriesKey === "units"
                  ? `${value} ${WattText}`
                  : `${value} ${KWHText}`;
              },
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              const data = series ? series?.flat() : [];

              return `<div class="custom_tooltip_contianer">
                <div class="custom_tooltip">
                <p style="margin:0" class="custon_para">
                ${labels[dataPointIndex]}
                </p>  
                </div>
                <div style="padding:9px">
                <div class="marker_with_content_container">
                <p class=${
                  SeriesKey === "units" ? "marker_color_yellow" : "marker_color"
                } 
                ></p>
                <p class="custon_para">
                Hourly:
                <span class="custom_span">
                ${
                  SeriesKey === "units"
                    ? data[dataPointIndex] + WattText
                    : data[dataPointIndex] + KWHText
                }
                </span>
                </p>
                </div>
                <div class="marker_with_content_container">
                <p class=${
                  SeriesKey === "units" ? "marker_color_yellow" : "marker_color"
                } ></p>
                <p class="custon_para">
                Time: 
                <span class="custom_span">${parseInt(
                  labels[dataPointIndex].split(":")[0]
                )} - ${
                parseInt(labels[dataPointIndex].split(":")[0]) + 1
              }</span>
                </p>
                </div>
                </div>
                </div>`;
            },
          },
          // title: {
          //   text: `${type}`,
          //   align: "left",
          // },
        }}
        series={[
          {
            name: "Hourly",
            data: series?.map((ele: any) => ele?.[SeriesKey]),
            color: colour,
          },
          // {
          //   name: "Units",
          //   data: series?.map((ele: any) => ele),
          //   color: "#f8ca00",
          // },

          // {
          //   name: "Completed SR",
          //   data: chartData?.map((ele: any) => ele?.totalCompleted),
          //   color: "#887e17",
          // },
          // {
          //   name: "Total SR",
          //   data: chartData?.map((ele: any) => ele?.totalRequest),
          //   color: "#fc911f",
          // },
        ]}
        type="bar"
        height={300}
      />
    </>
  );
}

export default BarChart;
